import { render, staticRenderFns } from "./FinanceDueInvoiceWidget.vue?vue&type=template&id=687740b0&"
import script from "./FinanceDueInvoiceWidget.vue?vue&type=script&lang=js&"
export * from "./FinanceDueInvoiceWidget.vue?vue&type=script&lang=js&"
import style0 from "./FinanceDueInvoiceWidget.vue?vue&type=style&index=0&id=687740b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports